import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const ThumbsDown = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { d: "M4.95 1.25H3.039s-1.788 0-1.788 1.804v5.559s0 1.804 1.788 1.804H4.88s1.787 0 1.787-1.804V3.054S6.684 1.25 4.951 1.25Zm10.613 14.446c0 .862 0 1.804-1.788 1.804-.943 0-1.164-.49-1.553-1.348-.35-.773-.834-1.843-2.101-3.123l-.07-.07c-.868-.876-1.718-1.733-1.718-2.617V3.125s.014-1.867 1.802-1.867h7.22c.77 0 1.395.671 1.395 1.45 0 .609-.383 1.142-.92 1.338.537.196.92.716.92 1.325a1.41 1.41 0 0 1-.92 1.325c.537.196.92.716.92 1.325a1.41 1.41 0 0 1-.92 1.325c.537.196.92.716.92 1.325 0 .779-.625 1.412-1.396 1.412h-3.579s1.787.905 1.787 3.613Z" }) }));
});
ThumbsDown.displayName = 'ThumbsDown';
export default ThumbsDown;
//# sourceMappingURL=ThumbsDown.js.map